import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Backdrop, CircularProgress } from '@mui/material';
import { greenColor } from '../../config/colors';
import { useCookiesLogin } from '../../config/cookies';
import api from '../../services/api';
import OnboardingOverlay from '.';
import ModalFirstConsult from './ModalFirstConsult';
import ModalApprovalSuccess from './ModalApprovalSuccess';
import { useAccessStage } from '../../context/AccessStageContext';
import { ACCESS_STAGE } from '../../constants';
import ModalInfo from './ModalInfo';

export default function OnboardingWrapper() {
  const { cookies } = useCookiesLogin();
  const response = cookies.AUTH_TOKEN || {};
  const [loading, setLoading] = useState(true);
  const [onboarding, setOnboarding] = useState(null);
  const [showFirstConsult, setShowFirstConsult] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [bonusGranted, setBonusGranted] = useState(false);
  const { setAccessStage } = useAccessStage();

  const handleCloseApprovalModal = () => {
    api.patch('/v1/auth/approval-notified').catch(() => {});
    setShowApprovalModal(false);
  };

  const handleCloseFirstConsult = () => {
    api.patch('/v1/user/bonus-notified').catch(() => {});
    setShowFirstConsult(false);
  };

  useEffect(() => {
    if (!cookies?.AUTH_TOKEN) {
      setLoading(false);
      return;
    }

    api
      .get('/v1/auth')
      .then(({ data }) => {
        const stage = data.access_stage || 'NONE';
        setAccessStage(stage);
        setOnboarding(data.onboarding);

        if (stage === ACCESS_STAGE.APPROVED && !data.approval_notified) {
          setShowApprovalModal(true);
        }

        if (data.bonus_granted && !data.bonus_notified && response.role === 'admin') {
          setBonusGranted(true);
          setShowFirstConsult(true);
        }
      })
      .catch(() => {
        setAccessStage('NONE');
        setOnboarding(true);
      })
      .finally(() => setLoading(false));
  }, [cookies?.AUTH_TOKEN]);

  if (loading) {
    return (
      <Backdrop open sx={{ zIndex: 9999 }}>
        <CircularProgress sx={{ color: greenColor }} />
      </Backdrop>
    );
  }

  if (onboarding === false && response.role === 'admin') {
    return (
      <>
        <OnboardingOverlay
          onNextStep={() => {
            setOnboarding(true);
            setAccessStage('PENDING');
            setShowInfoModal(true);
          }}
          onSkip={() => {
            setOnboarding(true);
            setShowInfoModal(true);
          }}
        />
        <Outlet />
      </>
    );
  }

  return (
    <>
      {bonusGranted && (
        <ModalFirstConsult
          open={showFirstConsult}
          onClose={handleCloseFirstConsult}
          onConsult={handleCloseFirstConsult}
        />
      )}
      <ModalInfo open={showInfoModal} onClose={() => setShowInfoModal(false)} />
      <ModalApprovalSuccess open={showApprovalModal} onClose={handleCloseApprovalModal} />
      <Outlet />
    </>
  );
}
